module.exports = __webpack_public_path__ + "img/meeting.05c5ceb6.svg";